<template>
  <div class="wrapper">
    <div style="margin-bottom:20px;">
      <el-button
        @click="handleEdit('',0)"
        type="primary"
        icon="el-icon-plus"
        v-auth="'sys:messageManage:add'"
      >{{$t('common.addNew')}}</el-button>
      <el-button @click="handelMessage" v-auth="'sys:messageManage:choice'" type="primary" icon="el-icon-s-comment">选择短信通道</el-button>
    </div>
    <div style="margin-bottom:20px;">
      <el-form :inline="true" :model="formSearch" class="demo-form-inline">
        <el-form-item :label="$t('message.messageClass')">
          <el-input v-model="formSearch.pushType" :placeholder="$t('message.messageClass')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.type')">
          <el-select
            v-model="formSearch.type"

            :placeholder="$t('message.type')"
          >
            <el-option :label="$t('message.verification')" value="1"></el-option>
            <el-option :label="$t('message.otherMessage')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-auth="'sys:messageManage:check'">
          <el-button type="primary" @click="onSubmitSearch">{{$t('common.search')}}</el-button>
          <el-button @click="resetSearch">{{$t('common.reset')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table border :data="messageLists" v-loading="loading"  style="width: 100%">
      <el-table-column :label="$t('message.moduleCode')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('message.content')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('message.ipLimit')" width="120">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.ipLimitTime }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('message.ipLimit')" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.isInternational==1" style="margin-left: 10px">国内</span>
          <span v-if="scope.row.isInternational==2" style="margin-left: 10px">国际</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('message.phoneLimit')" width="120">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.mobileLimitTime }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('message.messageClass')" width="120">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.pushType }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.remark')" width="120">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('message.time')" width="120">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.second }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="second" :label="$t('message.sendType')" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.sendType==0" style="margin-left: 10px">{{$t('message.autoSend')}}</span>
          <span v-if="scope.row.sendType==1" style="margin-left: 10px">{{$t('message.timeSend')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" :label="$t('message.type')" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.type==1" style="margin-left: 10px">{{$t('message.verification')}}</span>
          <span v-if="scope.row.type==2" style="margin-left: 10px">{{$t('message.otherMessage')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('common.status')" width="120" align="center">
        <template scope="scope">
          <el-button type="text" v-if="scope.row.status==2" plain>{{$t("common.stop")}}</el-button>
          <el-button type="text" v-if="scope.row.status==1" plain>{{$t("common.start")}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button size="mini" v-auth="'sys:messageManage:edit'"  @click="handleEdit(scope.row,1)">{{$t("common.edit")}}</el-button>
          <el-button
            type="info"
            size="mini"
            @click="blockUp(scope.row)"
            v-if="scope.row.status==1"
            v-auth="'sys:messageManage:stop'"
          >{{$t("common.stop")}}</el-button>
          <el-button
            type="success"
            size="mini"
            @click="startUsing(scope.row)"
            v-if="scope.row.status==2"
            v-auth="'sys:messageManage:stop'"
          >{{$t("common.start")}}</el-button>
          <el-button
            size="mini"
            type="danger"
            v-auth="'sys:messageManage:delete'"
            @click="handleDelete(scope.$index, scope.row)"
          >{{$t("common.delete")}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox">
      <el-form :model="form">
        <el-form-item :label="$t('message.moduleCode')" prop="code" :label-width="formLabelWidth">
          <el-input v-model="form.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.content')" prop="content" :label-width="formLabelWidth">
          <el-input v-model="form.content" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.ipLimit')"
          prop="ipLimitTime"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.ipLimitTime"
            auto-complete="off"
            :placeholder="$t('message.ipHolder')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.phoneLimit')"
          prop="mobileLimitTime"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.mobileLimitTime"
            auto-complete="off"
            :placeholder="$t('message.phoneHolder')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.messageClass')"
          prop="pushType"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.pushType" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.remark')" prop="remark" :label-width="formLabelWidth">
          <el-input v-model="form.remark" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.time')" prop="second" :label-width="formLabelWidth">
          <el-input
            v-model="form.second"
            auto-complete="off"
            :placeholder="$t('message.timeHolder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.sendType')" prop="sendType" :label-width="formLabelWidth">
          <el-select

            v-model="form.sendType"
            :placeholder="$t('message.sendType')"
          >
            <el-option label="自动发送" value="0"></el-option>
            <el-option label="定时发送" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国内或者国外" prop="isInternational" :label-width="formLabelWidth">
          <el-select

            v-model="form.isInternational"
            placeholder="请选择"
          >
            <el-option label="国内" value="1"></el-option>
            <el-option label="国际" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.type')" prop="type" :label-width="formLabelWidth">
          <el-select

            v-model="form.type"
            :placeholder="$t('message.type')"
          >
            <el-option label="验证码" value="1"></el-option>
            <el-option label="其他通知类" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="submitData">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
    <el-dialog :visible.sync="showMessageBox" title="短信通道">
      <template>
        <span style="font-weight: bold; font-size: 15px;">主通道：<br/><br/></span>
        <el-radio-group v-model="messageCode">
          <el-radio :label="item.label" v-for="item in messageCodeList" :key="item.lable">{{item.name}}</el-radio>
        </el-radio-group>
      </template>
      <template>
        <span style="font-weight: bold; font-size: 15px;"><br/><br/>备通道：<br/><br/></span>
        <el-radio-group v-model="messagePrepareCode">
          <el-radio :label="item.label" v-for="item in messageCodeList" :key="item.lable">{{item.name}}</el-radio>
        </el-radio-group>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showMessageBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="submitChannelData">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import {
  messageList,
  editmessageList,
  addmessageList,
  delmessageList,
  messageStatus,
  getMessageChannel,
  setMessageChannel
} from "@/api/sys/message";
import { Message, MessageBox } from "element-ui";
export default {
  data() {
    return {
      titleName: this.$t("common.edit"),
      messageLists: [],
      showEditBox: false,
      changeType: 1,
      formLabelWidth: "120px",
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      loading:false,
      showMessageBox:false,
      form: {
        code: "",
        content: "",
        id: 0,
        ipLimitTime: "",
        mobileLimitTime: "",
        pushType: "",
        remark: "",
        second: "",
        sendType: "0",
        type: "1",
        isInternational:'1'
      },
      formSearch: {
        type: "",
        pushType: ""
      },
      messageCode:"",
      messageCodeList:[],
      messagePrepareCode:"",
      messagePrepareCodeList:[]
    };
  },
  mounted() {
    this.getmessageList();
  },
  methods: {
    onSubmitSearch() {
      messageList(this.formSearch).then(res => {
        if (res.code == 0) {
          this.messageLists = res.result.list;
        }
      });
    },
    getmessageList() {
      let data = {
        code: "",
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        pushType: "",
        sendType: "",
        status: "",
        type: ""
      };
      messageList(data).then(res => {
        this.messageLists = res.result.list;
        this.totalSize = res.result.total;
        this.loading = false
      });
    },
    handleEdit(row, type) {
      let updateObject;
      updateObject = Object.assign({},row);
      this.changeType = type;
      if (this.changeType == 1) {
         this.form = updateObject;
        this.form.isInternational = String(row.isInternational)

        this.titleName = this.$t("common.edit");
      } else {
        for (let key in this.form) {
          this.form[key] = "";
        }
        this.titleName = this.$t("common.addNew");
      }
      this.showEditBox = true;
    },
    changeStatus(pram) {
      let data = {
        id: pram.id,
        status: pram.status
      };
      messageStatus(data).then(res => {
        if (res.code == 0) {
          console.log("更改成功");
        }
      });
    },
    startUsing(row) {
      row.status = 1;
      this.changeStatus(row);
    },
    blockUp(row) {
      row.status = 2;
      this.changeStatus(row);
    },
    resetSearch() {
      this.formSearch = {};
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancle"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delmessageList(row.id).then(res => {
              if (res.code == 0) {
                this.getmessageList();
              }
            });
            done();
          } else {
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t('common.conDelete')
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('common.canDele')
          });
        });
    },
    submitData() {
        this.form.isInternational = Number(this.form.isInternational)
      if (this.changeType == 1) {
        editmessageList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t('common.changeSu'),
              type: "success"
            });
          }
          this.getmessageList();
        });
      } else {
        addmessageList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t('common.addSu'),
              type: "success"
            });
          }
          this.getmessageList();
        });
      }

      this.showEditBox = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getmessageList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getmessageList();
    },
    handelMessage() {
      getMessageChannel().then(res => {
        this.messageCodeList = []
         this.showMessageBox = true
         for(let i in res.result){
           if(i == "check"){
             this.messageCode = res.result[i]
             continue;
           }
           if(i=="prepare"){
               this.messagePrepareCode=res.result[i];
               continue;
           }
           this.messageCodeList.push({label:i,name:res.result[i]})
         }


      });
    },
    submitChannelData(){
      setMessageChannel(this.messageCode,this.messagePrepareCode).then(res =>{
        if(res.code == 0 && res.result == true){
          console.log("success")
           this.showMessageBox = false;
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
</style>
